import { render, staticRenderFns } from "./ActivityStatusBadge.vue?vue&type=template&id=a2a3a9b6&scoped=true&"
import script from "./ActivityStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ActivityStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./ActivityStatusBadge.vue?vue&type=style&index=0&id=a2a3a9b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a3a9b6",
  null
  
)

export default component.exports